import { useEffect } from "react";

const sleep=(ms:number)=>new Promise(resolve=>window.setTimeout(resolve,ms));
const clean=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim();

function clickNav(label:string){
  const buttons=[...document.querySelectorAll<HTMLButtonElement>(".app-shell aside nav button")];
  const button=buttons.find(b=>clean(b.textContent).includes(label));
  button?.click();
  return Boolean(button);
}

async function openProcedure(documentNumber:string){
  if(!clickNav("WPS / WPDS Library"))return;
  for(let attempt=0;attempt<20;attempt++){
    await sleep(100);
    const rows=[...document.querySelectorAll<HTMLTableRowElement>(".procedure-table tbody tr")];
    const row=rows.find(r=>clean(r.querySelector("td:first-child b")?.textContent)===documentNumber);
    if(row){row.scrollIntoView({behavior:"smooth",block:"center"});row.click();return;}
  }
}

async function selectWelderDivision(program:string){
  const wantsAluminum=program==="w472";
  for(let attempt=0;attempt<30;attempt++){
    await sleep(75);
    const controls=[...document.querySelectorAll<HTMLButtonElement>(".division-control button, .division-tabs button, .welder-division button, button")];
    const button=controls.find(b=>{
      const text=clean(b.textContent).toLowerCase();
      return wantsAluminum ? text.includes("aluminum") : text.includes("steel");
    });
    if(button){
      button.click();
      await sleep(150);
      return;
    }
  }
}

async function findWelderRow(name:string,welderId:string){
  for(let attempt=0;attempt<35;attempt++){
    await sleep(100);
    const rows=[...document.querySelectorAll<HTMLTableRowElement>("table tbody tr")];
    const row=rows.find(r=>{
      const rowText=clean(r.textContent);
      const rowName=clean(r.querySelector("td:first-child b")?.textContent);
      return rowName.toLowerCase()===name.toLowerCase()||(welderId&&welderId!=="not entered"&&rowText.includes(welderId));
    });
    if(row)return row;
  }
  return null;
}

async function openWelder(name:string,welderId:string,program:string){
  if(!clickNav("Welder Qualifications"))return;
  await sleep(150);
  await selectWelderDivision(program);
  let row=await findWelderRow(name,welderId);

  // If the W47.2 division did not switch on the first pass, try the aluminum control once more.
  if(!row&&program==="w472"){
    await selectWelderDivision("w472");
    row=await findWelderRow(name,welderId);
  }

  if(!row)return;
  row.scrollIntoView({behavior:"smooth",block:"center"});
  row.dataset.openWelderProfile="true";
  row.click();
  window.setTimeout(()=>delete row.dataset.openWelderProfile,0);
}

export default function EligibilityResultNavigation(){
  useEffect(()=>{
    const onClick=(event:MouseEvent)=>{
      const target=event.target as HTMLElement;

      const profileRow=target.closest("tr[data-open-welder-profile='true']") as HTMLTableRowElement|null;
      if(profileRow){
        const hadClickRow=profileRow.classList.contains("click-row");
        if(hadClickRow)profileRow.classList.remove("click-row");
        window.setTimeout(()=>{if(hadClickRow)profileRow.classList.add("click-row")},0);
        return;
      }

      const card=target.closest(".eligibility-candidates .candidate-card") as HTMLElement|null;
      if(!card)return;

      const title=clean(card.querySelector("b")?.textContent);
      if(!title)return;

      const resultType=clean(card.querySelector(".decision")?.textContent).toUpperCase();
      const program=(document.querySelector(".eligibility-form select") as HTMLSelectElement|null)?.value||"w471";
      event.preventDefault();
      event.stopPropagation();

      if(resultType==="APPLICABLE"){
        void openProcedure(title);
        return;
      }

      if(resultType==="QUALIFIED"){
        const small=clean(card.querySelector("small")?.textContent);
        const match=small.match(/Welder ID\s+(.+)/i);
        void openWelder(title,clean(match?.[1]),program);
      }
    };

    document.addEventListener("click",onClick,true);
    return()=>document.removeEventListener("click",onClick,true);
  },[]);
  return null;
}
